import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reaserch',
  templateUrl: './reaserch.component.html',
  styleUrls: ['./reaserch.component.scss']
})
export class ReaserchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
